import React from 'react';
import './ScholarshipPage.css';

const ScholarshipPage: React.FC = () => {
  return (
    <div className="scholarship-page">
      <section className="scholarship-hero">
        <div className="container">
          <h1>Scholarship Program</h1>
          <p className="subtitle">No kid with real heart and hunger gets turned away</p>
        </div>
      </section>

      <section className="scholarship-story">
        <div className="container">
          <div className="story-content">
            <div className="story-text">
              <h2>Football saved me.</h2>
              <p>
                I grew up in a house where money was always tight, but the game gave me coaches who believed in me, 
                discipline when I needed it most, and a clear path forward. That experience shaped everything I do.
              </p>
              <p>
                Because of it, no kid with real heart and hunger will ever be turned away from Xcelerate just because 
                the dollars aren't there right now. If a family is grinding and needs help, we'll figure it out together. 
                Reduced rate, a little extra help spreading the word, or a full ride; whatever it takes.
              </p>
              <p className="story-emphasis">
                If the effort is real, we'll always find a way to make it happen. That's how we do things here.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="scholarship-form-section">
        <div className="container">
          <div className="form-intro">
            <h2>Apply for a Scholarship</h2>
            <p>
              Tell us about your situation, your goals, and your commitment to the game. 
              We'll review every application personally and get back to you within 48 hours.
            </p>
          </div>
          
          <div className="jotform-container">
            <iframe
              id="JotFormIFrame-253256034203042"
              title="Scholarship Application"
              allowTransparency={true}
              allow="geolocation; microphone; camera; fullscreen"
              src="https://form.jotform.com/253256034203042"
              frameBorder="0"
              style={{
                minWidth: '100%',
                maxWidth: '100%',
                height: '1200px',
                border: 'none'
              }}
              scrolling="yes"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ScholarshipPage;

